import axios from "axios";

import {useState, useEffect} from 'react'
import { useNavigate, Navigate, useLocation } from 'react-router-dom';

import Navbar from './Navbar'
import Topbar from './Topbar'
import {APIURL} from './config'

function NovoComentarioIdeia() {

    const locate = useLocation()

    const navigate = useNavigate()

    const myid = locate.state.ideia_id
    const mytitulo = locate.state.titulo


    const [descricao, setDescricao] = useState()

    useEffect(() => {
        if (!sessionStorage.getItem("tokeninovacao")) {
            navigate('/login')
        }
    }, [])

    const  doSend = async (e) => {
        e.preventDefault()
        try {
            alert(sessionStorage.getItem("tokeninovacao") + " " + myid + " " + descricao)
            const res = await axios.post(`${APIURL}/Inovation/AddMessageToIdea`, {TOKEN:  sessionStorage.getItem("tokeninovacao") , Id : myid, Message: descricao})
            if (res.data.Return) {
                navigate("/ideiaunica", {state:{ideia_id: myid}})
            } else {
                alert(res.data.Description)
            }
        }
        catch(err){
            alert(err)
        }

    }


  return (
    <div>
        <Topbar />
        <div className="container py-4 px-2 px-md-5 ">
            <div className="h4 mb-0">Novo Comentário</div>
            <div className="small mb-3">{mytitulo}</div>
            <div className="bg-white shadow-sm p-5">
                <div className="row ">
                    <div className="col-12">
                        <form onSubmit={(e)=> doSend(e)} role="form" >
                            <div className="form-group mb-3"><label>Comentário</label> <textarea  rows={6}  className="form-control" onChange={(e)=> setDescricao(e.target.value)}/></div>
                            <div>
                                <button className="btn btn-md btn-success" type="submit">ENVIAR</button>
                                
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default NovoComentarioIdeia;